var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiglogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 278,
    viewBox: "0 0 337 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 86,
    width: 42,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.518 122L139.69 121.963L119.119 122L139.8 86.0422L160.518 122Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 85,
    width: 43,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.589 85.3066H118.495V121.998H160.589V85.3066Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.817 67.6953H100.815V140.345H178.817V67.6953Z",
    fill: "#5D5A5B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 0,
    width: 64,
    height: 86
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.443 60.9817L168.387 85.3817L119.119 0L147.267 0.0366926L182.443 60.9817Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 0,
    width: 65,
    height: 87
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.551 0H118.495V86.2256H182.551V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.743 -18.345H100.815V103.728H200.743V-18.345Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 86,
    width: 42,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.923 122L196.096 121.963L175.524 122L196.242 86.0422L216.923 122Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 85,
    width: 43,
    height: 37
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.324 85.3069H175.23V121.999H217.324V85.3069Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.223 67.6953H157.221V140.345H235.223V67.6953Z",
    fill: "#5D5A5B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 0,
    width: 65,
    height: 122
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8181 60.9817L62.6787 0H90.9L126.003 60.9817L90.9 122H62.6787L97.8181 60.9817Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 0,
    width: 65,
    height: 122
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.736 0H62.6797V122H126.736V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.304 -18.345H44.376V140.347H144.304V-18.345Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 0,
    width: 99,
    height: 122
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.767 122H273.988L238.848 60.9817L203.746 0H175.524L210.664 60.9817L245.767 122Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 0,
    width: 100,
    height: 122
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M274.06 0H175.23V122H274.06V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.288 -18.345H157.221V140.347H292.288V-18.345Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 157,
    width: 337,
    height: 77
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M313.297 222.065H319.991C321.755 222.065 323.238 221.422 324.481 220.136C325.683 218.85 326.285 217.364 326.285 215.636V177.223C326.285 175.495 325.683 173.968 324.441 172.723C323.198 171.477 321.715 170.834 319.991 170.834H313.297V222.025V222.065ZM336.666 214.832C336.666 219.694 334.983 223.833 331.576 227.288C328.169 230.744 324.12 232.471 319.35 232.471H302.034V158.74H319.35C324.16 158.74 328.249 160.468 331.616 163.923C334.983 167.379 336.666 171.517 336.666 176.339V214.872V214.832ZM266.279 158.7L281.23 208.243V158.7H292.534V232.431H280.428L264.876 185.219V232.431H253.612V158.7H266.319H266.279ZM244.072 232.431H232.809V158.7H244.072V232.431ZM181.661 232.431H170.518V158.7H186.551L196.973 211.577L206.994 158.7H222.427V232.431H211.243V186.103L201.543 232.431H192.524L181.661 186.223V232.431ZM163.583 232.431H133.28V158.7H144.343V221.422H163.543V232.471L163.583 232.431ZM110.792 174.651C110.792 172.843 110.191 171.316 109.029 170.071C107.866 168.825 106.423 168.222 104.74 168.222C103.056 168.222 101.653 168.825 100.451 170.071C99.2483 171.316 98.647 172.843 98.647 174.651V215.596C98.647 217.364 99.2483 218.89 100.451 220.136C101.653 221.382 103.056 222.025 104.74 222.025C106.423 222.025 107.866 221.382 109.029 220.136C110.191 218.89 110.792 217.364 110.792 215.596V174.651ZM106.423 157.816C111.233 157.816 115.362 159.543 118.729 162.999C122.096 166.455 123.78 170.593 123.78 175.495V215.676C123.78 220.578 122.096 224.757 118.689 228.172C115.282 231.588 111.193 233.315 106.423 233.315C101.653 233.315 97.5647 231.588 94.1977 228.132C90.8306 224.676 89.1872 220.538 89.1872 215.636V175.455C89.1872 170.553 90.8707 166.374 94.2778 162.959C97.685 159.543 101.733 157.816 106.423 157.816ZM66.6599 174.651C66.6599 172.843 66.0586 171.316 64.8962 170.071C63.7337 168.825 62.2907 168.222 60.6072 168.222C58.9236 168.222 57.5207 168.825 56.3182 170.071C55.1157 171.316 54.5144 172.843 54.5144 174.651V215.596C54.5144 217.364 55.1157 218.89 56.3182 220.136C57.5207 221.382 58.9236 222.025 60.6072 222.025C62.2907 222.025 63.7337 221.382 64.8962 220.136C66.0586 218.89 66.6599 217.364 66.6599 215.596V174.651ZM60.527 157.816C65.3371 157.816 69.4658 159.543 72.8328 162.999C76.1999 166.455 77.8834 170.593 77.8834 175.495V215.676C77.8834 220.578 76.1999 224.757 72.7927 228.172C69.3856 231.588 65.297 233.315 60.527 233.315C55.757 233.315 51.6684 231.588 48.3014 228.132C44.9343 224.676 43.2908 220.538 43.2908 215.636V175.455C43.2908 170.553 44.9744 166.374 48.3815 162.959C51.7887 159.543 55.8372 157.816 60.527 157.816ZM11.1033 209.126V232.431H0V158.7H11.1033V184.978L24.5315 158.7H36.3563L21.2446 188.875L38.9618 232.471H25.9745L14.3902 202.577L11.1434 209.167L11.1033 209.126Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 157,
    width: 338,
    height: 78
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336.667 157.855H-0.0400391V234.199H336.667V157.855Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.71 137.767H-20.0811V253.447H356.71V137.767Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 255,
    width: 233,
    height: 23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M277.141 264.777H278.503C279.505 264.777 280.187 264.294 280.548 263.29C280.668 262.928 280.748 262.446 280.748 261.924C280.748 261.04 280.548 260.357 280.107 259.875C279.706 259.433 279.185 259.232 278.543 259.232H277.181V264.777H277.141ZM277.141 274.34H278.503C279.626 274.34 280.387 273.777 280.788 272.612C280.948 272.21 281.029 271.768 281.029 271.286C281.029 270.08 280.788 269.196 280.347 268.634C279.946 268.112 279.345 267.87 278.543 267.87H277.181V274.34H277.141ZM273.653 277.554V255.937H278.503C279.786 255.937 280.949 256.258 281.991 256.941C282.873 257.504 283.514 258.428 283.875 259.593C284.075 260.236 284.195 261 284.195 261.884C284.195 263.33 283.794 264.495 283.033 265.379C282.712 265.741 282.311 266.022 281.91 266.223C282.632 266.504 283.233 267.027 283.754 267.87C284.075 268.433 284.356 269.116 284.516 270C284.596 270.442 284.636 270.964 284.636 271.487C284.636 272.853 284.396 274.018 283.875 274.982C283.474 275.746 282.913 276.308 282.151 276.791C281.309 277.313 280.508 277.554 279.706 277.554H273.693H273.653ZM250.725 260.879L249.523 269.397H251.928L250.725 260.879ZM249.001 272.572L248.2 277.554H244.833L248.48 255.937H252.97L256.577 277.554H253.17L252.409 272.572H249.001ZM227.757 277.554H218.898V255.937H222.145V274.34H227.757V277.594V277.554ZM197.814 260.758C197.814 260.236 197.654 259.794 197.293 259.433C196.932 259.071 196.491 258.91 195.97 258.91C195.449 258.91 195.008 259.071 194.647 259.433C194.287 259.794 194.086 260.236 194.086 260.758V272.612C194.086 273.134 194.287 273.576 194.647 273.938C195.008 274.299 195.449 274.5 195.97 274.5C196.491 274.5 196.932 274.299 197.293 273.938C197.654 273.576 197.814 273.134 197.814 272.612V260.758ZM196.05 255.656C197.493 255.656 198.696 256.178 199.698 257.182C200.7 258.187 201.221 259.433 201.221 260.839V272.652C201.221 274.098 200.7 275.304 199.698 276.308C198.696 277.313 197.453 277.835 196.05 277.835C194.647 277.835 193.405 277.313 192.403 276.308C191.401 275.304 190.92 274.058 190.92 272.652V260.839C190.92 259.392 191.441 258.187 192.443 257.182C193.445 256.178 194.647 255.656 196.05 255.656ZM165.667 255.897L169.956 270.442V255.897H173.202V277.514H169.715L165.226 263.652V277.514H161.979V255.897H165.627H165.667ZM137.127 268.393V277.554H133.88V255.937H137.127V265.138H141.015V255.937H144.262V277.554H141.015V268.393H137.127ZM111.232 277.835C109.789 277.835 108.587 277.313 107.585 276.349C106.583 275.344 106.102 274.139 106.102 272.692V260.839C106.102 259.392 106.623 258.187 107.625 257.182C108.627 256.178 109.829 255.656 111.272 255.656C112.715 255.656 113.918 256.178 114.92 257.182C115.922 258.187 116.403 259.433 116.403 260.839V263.29H113.036V260.758C113.036 260.236 112.836 259.794 112.475 259.433C112.114 259.071 111.673 258.87 111.152 258.87C110.631 258.87 110.19 259.071 109.829 259.433C109.469 259.794 109.268 260.236 109.268 260.758V272.652C109.268 273.174 109.469 273.616 109.829 273.978C110.19 274.34 110.631 274.54 111.152 274.54C111.673 274.54 112.114 274.34 112.475 273.978C112.836 273.616 113.036 273.174 113.036 272.652V269.679H116.403V272.692C116.403 274.139 115.882 275.344 114.88 276.349C113.878 277.353 112.675 277.835 111.232 277.835ZM79.7663 277.554V255.937H89.0258V259.191H83.0132V265.098H87.4224V268.353H83.0132V274.259H89.0258V277.514H79.7663V277.554ZM55.6357 259.191H52.1885V255.937H62.3298V259.191H58.8825V277.554H55.6357V259.191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_701_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_701_2999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 255,
    width: 234,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M285.558 255.294H52.0684V278.398H285.558V255.294Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_701_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.639 235.606H32.1074V297.966H304.639V235.606Z",
    fill: "#5D5A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiglogo);
export default __webpack_public_path__ + "static/media/biglogo.6fd94fdc7456f5b5253b8f7450440c8e.svg";
export { ForwardRef as ReactComponent };